import React from 'react';
import { MarkdownPreview,  } from './MarkdownPreview';
import type { MarkdownMentionPreviewContext } from '../types';

export const Preview = ({
    show,
    content,
    className,
    mentionPreviewContext
  }: {
  show: boolean;
  content: string;
  className?: string;
  mentionPreviewContext?: MarkdownMentionPreviewContext;
}) => {
  if (!show) return null;

  return (
    <MarkdownPreview content={content} className={className} mentionPreviewContext={mentionPreviewContext} />
  );
};